import type { Option } from 'commons/modules/items';

type CreateOptionParams = {
  label: string;
  value: unknown;
  disabled?: boolean;
  sequenceId?: number;
  description?: string;
};

export const createOption = ({
  label,
  value,
  disabled = false,
  sequenceId = 0,
  description = '',
}: CreateOptionParams): Option => ({
  label,
  value,
  disabled,
  sequenceId,
  description,
});
